import { Injectable } from '@angular/core';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import {
  DvCheckboxElement,
  DvCountryDropdownElement,
  DvNumberboxElement,
  DvSpaceElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';

@Injectable()
export class NewPoiDialogService {
  readonly elements: DvDynamicFormElement[] = [
    new DvTextboxElement({
      colspan: 12,
      key: 'Description',
      label: 'POI.Information.Description',
    }),
    new DvTextboxElement({
      colspan: 12,
      key: 'Address',
      label: 'POI.Address',
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'PostalNumber',
      label: 'POI.PostalNumber',
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'PostalPlace',
      label: 'POI.PostalPlace',
      disabled: true,
    }),
    new DvCountryDropdownElement({
      colspan: 6,
      key: 'CountryCode',
      label: 'POI.Country',
      disabled: true,
      readonly: true,
    }),
    new DvSpaceElement({
      colspan: 6,
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'GPSLat',
      label: 'POI.Lat',
      disabled: true,
    }),
    new DvNumberboxElement({
      colspan: 6,
      key: 'GPSLon',
      label: 'POI.Lon',
      disabled: true,
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'AcceptanceRadius',
      label: 'POI.AcceptanceRadius',
    }),
    new DvSpaceElement({
      colspan: 6,
    }),
    new DvCheckboxElement({
      colspan: 12,
      key: 'Active',
      checkboxLabel: 'POI.Active',
    }),
    new DvTextboxElement({
      colspan: 12,
      key: 'Purpose',
      label: 'POI.Purpose',
    }),
    new DvCheckboxElement({
      colspan: 12,
      key: 'Personal',
      checkboxLabel: 'POI.Private',
    }),
  ];
}
